import { LuHouse } from 'react-icons/lu';

import type { NavItem } from 'src/shared/components/shell/navTypes';

export const homeNav: NavItem[] = [
  { icon: LuHouse, label: 'Inicio', to: '/', placement: 'primary' },
];
